module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_6.b0ea1109.png";